module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_footer_image_02-c3b89762cc05a66499331cec9cdb09f8.jpg";